import { Injectable } from "@angular/core";
import { CartService } from "src/app/dashboard/cart/cart.service";
import { PriceService } from "src/app/dashboard/price/price.service";
import { BuyRequest } from "src/app/model/shop/buy-request";
import { SellRequest } from "src/app/model/shop/sell-request";
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";
import { UserService } from "./user.service";
import {CheckoutService} from '../app/dashboard/checkout/checkout.service';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(
    private restApiService: RestApiService,
    private priceService: PriceService,
    private userService: UserService,
    private cartService: CartService
  ) {}

  endpoint = "product/";

  buy(buyRequest: BuyRequest) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "buy",
      buyRequest
    );
  }

  getBasketTax(afterPuchaseType) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "basket-tax",
      {
        afterPuchaseType,
        ...this.cartService.buyRequest.value,
        country: this.userService.user.value.country,
        priceJwt: this.priceService.priceJwt.value,
      }
    );
  }

  sell(sellRequest) {
    return this.restApiService.post(ServerType.WALLET, this.endpoint + "sell", {
      ...sellRequest,
      priceJwt: this.priceService.priceJwt.value,
    });
  }

  getShipmentCost(afterPurchaseType, country) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "shipment-cost",
      {
        afterPurchaseType,
        ...this.cartService.buyRequest.value,
        country,
        priceJwt: this.priceService.priceJwt.value
      }
    ).pipe(
      catchError(() => {
        return of(0);
      }));
  }
}
